import React, { useEffect, useState } from 'react';
import Calling from '../api/Calling';

const LoadChecker = ({ isMobile = false }) => {
    const [loadData, setLoadData] = useState({
        cpuLoad: null,
        ramUsage: null,
        storageUsage: null,
        liveView: 0,
    });

    const fetchStats = async () => {
        try {
            const response = await Calling.getServerLoadCheck();
            if (response?.status) {
                setLoadData({
                    cpuLoad: response.cpuLoad,
                    ramUsage: response.ramUsage,
                    storageUsage: response.storageUsage,
                    liveView: response.liveView,
                });
            }
        } catch (error) {
            console.error('Error fetching system stats:', error);
        }
    };

    useEffect(() => {
        fetchStats();
        const interval = setInterval(fetchStats, 5000);
        return () => clearInterval(interval);
    }, []);

    const getLoadColor = (value) => {
        if (value < 50) return 'text-green-600';
        if (value <= 80) return 'text-yellow-600';
        return 'text-red-600';
    };

    const getViewColor = (value) => {
        if (value < 100) return 'text-green-600';
        if (value <= 500) return 'text-yellow-600';
        return 'text-red-600';
    };

    const LoadItem = ({ label, value, colorFunc }) => (
        <div className={`flex flex-col items-center ${isMobile ? 'py-1' : 'border-r border-main-border pr-3 last:border-r-0'}`}>
            {value !== null ? (
                <span className={`font-semibold text-sm sm:text-base ${colorFunc(value)}`}>
                    {value}{label !== 'View' && '%'}
                </span>
            ) : (
                <div className="h-5 flex items-center justify-center">
                    <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                </div>
            )}
            <span className="text-xs sm:text-sm text-main-subfont">{label}</span>
        </div>
    );

    return (
        <div className={`relative flex ${isMobile ? 'flex-wrap justify-around gap-3 py-2 px-1' : 'items-center gap-3 sm:gap-6 md:gap-10 px-3 py-2'} bg-white rounded-md shadow-sm`}>
            {!isMobile && <div className="absolute top-0 left-0 h-full w-1 rounded-l-md bg-green-500"></div>}
            <LoadItem label="CPU" value={loadData.cpuLoad} colorFunc={getLoadColor} />
            <LoadItem label="RAM" value={loadData.ramUsage} colorFunc={getLoadColor} />
            <LoadItem label="Storage" value={loadData.storageUsage} colorFunc={getLoadColor} />
            <LoadItem label="View" value={loadData.liveView} colorFunc={getViewColor} />
        </div>
    );
};

export default LoadChecker;
